var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{attrs:{"aside":"","show":_vm.$store.state.asideShow,"colorScheme":"light","overlaid":"","size":"lg"},on:{"update:show":(val) => _vm.$store.commit('set', ['asideShow', val])}},[_c('CSidebarClose',{nativeOn:{"click":function($event){return _vm.$store.commit('toggle', 'asideShow')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }